module.exports = __webpack_public_path__ + "img/cifa.d544cfb2.png";